<div class="seperator"></div>
<div class="title" mat-dialog-title>Enable Channel Factory</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">Please schedule a daily Channel Factory report and send to below email: </div>
        <div class="ias-email">
            {{cfEmail}}
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
    </div>
</div>